import { UserGroupInfo } from '@models/User/usergroupinfo.model';
import { WaterScheduleInfo } from '@models/Irrigation/waterScheduleInfo';
import { GpsInfo } from '@models/Map/gpsInfo.model';
import { DeviceCameraInfo } from './DeviceCamera';
import { Sensor } from '@models/Sensor/sensor.model';


export class DeviceInfo {
    id: number;
    name: string;
    description: string;
    //type: DeviceType;
    mode: string;
    registerDate: Date;
    version?: string;
    serialNumber: string;
    macAddress: string;
    ipAddress: string;
    netmask: string;
    networkInterface: string;

    gpsLocation: GpsInfo;
    sensorUUIDs: string[];
    //sensors?: Sensor[];
    deviceWaterScheduleInfos: WaterScheduleInfo[];
    waterRate: number;                             // in gallons per minute

    deviceNotifications: DeviceNotificationInfo[];
    notificationDestination: string;

    userName: string;
    userGroup: string;
    userGroupId: number;

    isDisabled: boolean;

    mountAngle: number;
    deviceCameras?: DeviceCameraInfo[];
    deviceFunctionIds?: number[];
}



export enum DeviceNotificationType {
    NoDeviceResponse = 'NoDeviceResponse',
    NoSensorResponse = 'NoSensorResponse',
    ValueResponse = 'ValueResponse'
  }

export class DeviceNotificationInfo {
    id: number;
    type: DeviceNotificationType;
    isEnabled: boolean;
    missedCount: number;
    timeSpan: number;
    sensorValue: number;
    dataTypeID: number;
}
